export default {
  en: {
    landing: {
      recentSupplier: 'Recently visited suppliers',
      recentClient: 'Recently visited clients',
      recentEmpty: 'No recently viewed organisations',
      browseSuppliers: 'Browse all suppliers',
      supplier: 'Supplier',
      client: 'Client',
      viewAllSuppliers: 'View all suppliers',
      getFailed: 'Failed to get quick connect profiles',
    },
    filters: {
      connectedStatusConnected: 'Connected',
      connectedStatusNotConnected: 'Not connected',
      orgTypeClient: 'Client',
      orgTypeSupplier: 'Supplier',
    },
    org: {
      managed: {
        title: 'RL managed',
        description: 'This profile has been created and is managed by Risk Ledger.',
      },
      unclaimed: 'Unclaimed',
      trialRestricted: 'Trial restricted',
      trialRestrictedDescription: 'This profile is not included in your trial.',
    },
    results: {
      cantFindSupplier: "Can't find the supplier you're looking for?",
      noMatches: 'No matching results',
      tryDifferentSearch: 'Try searching for something else or change your filters.',
      createNewSupplier: 'Create new supplier {name}',
      createSupplier: 'Create supplier',
      noResults: 'No results found',
      resultsCount: '{n} result | {n} results',
      showAll: 'See all...',
    },
    bar: {
      searchSupplier: 'Search for a supplier...',
      searchClient: 'Search for a client...',
      failed: 'Search failed',
      search: 'Search',
    },
    nav: {
      title: 'Search',
      searchSuppliers: 'Search suppliers',
      searchClients: 'Search clients',
    },
  },
};
